import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'lib/core/data/reducer'
import { Slice, CountryInfoSlice, RegionOption, CountryInfoOption } from './types'

export const getSlice = (countryCode?: string) => (state: RootState): CountryInfoSlice | undefined => {
  return countryCode ? state.common.countryInfo[countryCode] : undefined
}

export const getCountryInfoOptions = createSelector(
  (state: any) => state.common.countryInfo,
  (countryInfo: Slice) => {
    const items: CountryInfoOption[] = []
    Object.values(countryInfo).forEach(country => {
      if (country?.payload && country.isSuccess) {
        const { id: value, full_name_locale: label } = country.payload
        items.push({
          value,
          label
        })
      }
    })

    return items
  }
)

export const getRegionOptions = (countryCode?: string) => createSelector(
  getSlice(countryCode),
  country => {
    const items: RegionOption[] = []
    if (country?.payload && country.isSuccess) {
      const { available_regions: regions } = country.payload
      regions?.forEach(region => {
        const { id, code: value, name: label } = region
        items.push({
          id,
          value,
          label
        })
      })
    }

    return items
  }
)

export const getRegionOptionByCode = (countryCode: string, regionCode?: string) => createSelector(
  getSlice(countryCode),
  country => {
    if (country?.payload && country.isSuccess) {
      const { available_regions: regions } = country.payload
      const region = regions.find(region => region.code === regionCode)
      if (region) {
        const { id, code: value, name: label } = region
        const option: RegionOption = {
          id,
          value,
          label
        }
        return option
      }
    }
  }
)

export const getIsFetching = (countryCodes: string[]) => createSelector(
  (state: RootState) => state.common.countryInfo,
  (countryInfo: Slice) => {
    let isFetching = false
    countryCodes.forEach(countryCode => {
      const country = countryInfo[countryCode]
      isFetching = isFetching || (country && !country.isSuccess)
    })
    return isFetching
  }
)
